<div style="position: relative" [id]="ContainerId">
  <div class="filter-container" [ngClass]="{'filter-container-open': FilterOpen}" (click)="openFilter()">
    <div class="placeholder-container">
      <img [src]="IconUrl" alt="">
      <p>{{PlaceholderFilter}}</p>
    </div>
    <img class="chevron-icon" [ngClass]="{'transform-rotation-180': FilterOpen}" src="/assets/icons/chevron-down.svg"
      alt="">
  </div>

  <div class="absolut-container" [style.width]="PopupWidth ? PopupWidth : '300px'" *ngIf="FilterOpen">
    <div *ngIf="Options && Options.length > 0">
      <div class="options-list-container">
        <div *ngFor="let option of Options; let i = index; let last = last">
          <div class="split" *ngIf="i != 0"></div>
          <div class="option-container" (click)="emitFilterValue(option)">
            <img [src]="option.Icon" alt="">
            {{option.TranslateKey | translate}}
          </div>
        </div>
      </div>

    </div>
  </div>
</div>